import { errorToaster } from '../utils/toastFunctions'
import { get } from 'lodash'

function errorFormatter(error) {
  let message = get(error, 'networkError.message') ||
              get(error, 'graphQLErrors[0].message') ||
              get(error, '[0].message', error.message) // the last case needs a defaultValue
  if(message){
    errorToaster(message)
  }else{
    message = error
    errorToaster(message, false)
  }
}

export {
  errorFormatter
}